import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Select from 'react-select';
import { DateRangePicker } from 'react-dates';
import moment from 'moment';
import _ from 'lodash';
import * as MODEL from '~/constants/ModelConstants';
import * as searchActions from '~/search2/actions';
const DROPDOWN_OPT_KEY = 'DROPDOWN_OPT_KEY';
type CSDateFilterProps = {
  actions: object;
  searchDataState: object;
  name: string;
  type?: 'all' | 'library' | 'vulnerability';
};
class CSDateFilter extends React.Component<CSDateFilterProps, {}> {
  componentDidUpdate(prevProps) {
    const { name, type } = this.props;
    const { filters: currentFilter = {} } = this.props.searchDataState;
    const { filters: oldFilters = {} } = prevProps.searchDataState;
    // Update the component for first load
    if (!oldFilters[name] && currentFilter[name]) {
      this.parseAndUpdateVal(currentFilter[name]);
    }
    // Remove the date option when selected type:library
    if (type === 'vulnerability') {
      if (
        _.includes(oldFilters.type, 'vulnerability') &&
        _.includes(currentFilter.type, 'library')
      ) {
        this.clearDateFields();
      }
    }
    // Remove the date option when selected type:vulnerability
    if (type === 'library') {
      if (
        _.includes(oldFilters.type, 'library') &&
        _.includes(currentFilter.type, 'vulnerability')
      ) {
        this.clearDateFields();
      }
    }
    // When user manually update the text in the search, update severity
    if (oldFilters[name] !== currentFilter[name]) {
      this.parseAndUpdateVal(currentFilter[name]);
    }
  }
  isRangeVal(val) {
    let validRange = false;
    if (val.length > 0 && val.includes(MODEL.RANGE_SPLITTER)) {
      validRange =
        val
          .split(MODEL.RANGE_SPLITTER)
          .map(item => moment(item))
          .filter(item => !item.isValid()).length == 0;
    }
    return validRange;
  }
  isSingleVal(val) {
    let validSingleVal = false;
    if (val.length > 0 && !val.includes(MODEL.RANGE_SPLITTER)) {
      const valToCheck = val.startsWith('<') ? val.substring(1, val.length) : val;
      validSingleVal = moment(valToCheck).isValid();
    }
    return validSingleVal;
  }
  parseAndUpdateVal = val => {
    if (this.isRangeVal(val)) {
      const dates = val.split(MODEL.RANGE_SPLITTER);
      this.updateDateOpt(DROPDOWN_OPT_KEY, 'custom');
      this.updateDateOpt('startDate', moment(dates[0]));
      this.updateDateOpt('endDate', moment(dates[1]));
    } else if (this.isSingleVal(val)) {
      if (val.startsWith('<')) {
        this.updateDateOpt(DROPDOWN_OPT_KEY, 'custom');
        this.updateDateOpt('startDate', null);
        this.updateDateOpt('endDate', moment(val.substring(1, val.length)));
      } else {
        const possibleDropDownVal = this.getDropDownValueFromDate(val);
        if (possibleDropDownVal) {
          this.updateDateOpt(DROPDOWN_OPT_KEY, possibleDropDownVal);
          this.updateDateOpt('startDate', null);
          this.updateDateOpt('endDate', null);
        } else {
          this.updateDateOpt(DROPDOWN_OPT_KEY, 'custom');
          this.updateDateOpt('startDate', moment(val));
          this.updateDateOpt('endDate', null);
        }
      }
    } else {
      // Invalid date
      this.clearDateFields();
    }
  };
  clearDateFields() {
    this.updateDateOpt(DROPDOWN_OPT_KEY, '');
    this.updateDateOpt('startDate', null);
    this.updateDateOpt('endDate', null);
  }
  updateFilter = val => {
    const { name } = this.props;
    this.props.actions.setFilter(name, val);
  };
  updateDateOpt(key, val) {
    const { name } = this.props;
    this.props.actions.updateDateOpt(`${name}-${key}`, val);
  }
  onDropdownListSelected(item) {
    if (item === null) {
      this.updateFilter(null);
      this.updateDateOpt(DROPDOWN_OPT_KEY, '');
    } else if (item.value === 'custom') {
      this.updateFilter(null);
      this.updateDateOpt(DROPDOWN_OPT_KEY, item.value);
      this.updateDateOpt('startDate', null);
      this.updateDateOpt('endDate', null);
    } else {
      const updatedDate = this.getDateFromDropdownlistValue(item.value);
      if (updatedDate) {
        this.updateFilter(moment(updatedDate).format('YYYY-MM-DD'));
      }
      this.updateDateOpt(DROPDOWN_OPT_KEY, item.value);
    }
  }
  onCustomRangeSelect(startDate, endDate) {
    this.updateDateOpt('startDate', startDate);
    this.updateDateOpt('endDate', endDate);
    if (startDate && endDate) {
      this.updateFilter(
        `${moment(startDate).format('YYYY-MM-DD')}${MODEL.RANGE_SPLITTER}${moment(endDate).format(
          'YYYY-MM-DD'
        )}`
      );
    } else if (startDate && !endDate) {
      this.updateFilter(`${moment(startDate).format('YYYY-MM-DD')}`);
    } else if (!startDate && endDate) {
      this.updateFilter(`<${moment(endDate).format('YYYY-MM-DD')}`);
    } else if (!startDate && !endDate) {
      this.updateFilter(null);
    }
  }
  getDropDownValueFromDate(date) {
    if (
      moment()
        .subtract(7, 'days')
        .format('YYYY-MM-DD') === date
    ) {
      return 'last7days';
    }
    if (
      moment()
        .subtract(14, 'days')
        .format('YYYY-MM-DD') === date
    ) {
      return 'last14days';
    }
    if (
      moment()
        .subtract(30, 'days')
        .format('YYYY-MM-DD') === date
    ) {
      return 'last30days';
    }
    if (
      moment()
        .subtract(3, 'months')
        .format('YYYY-MM-DD') === date
    ) {
      return 'last3months';
    }
    return null;
  }
  getDateFromDropdownlistValue(dropdownVal) {
    switch (dropdownVal) {
      case 'last7days':
        return moment().subtract(7, 'days');
      case 'last14days':
        return moment().subtract(14, 'days');
      case 'last30days':
        return moment().subtract(30, 'days');
      case 'last3months':
        return moment().subtract(3, 'months');
      default:
        break;
    }
    return null;
  }
  shouldDisableDateFields = () => {
    const { type, searchDataState } = this.props;
    const { filters = {} } = searchDataState;
    let shouldDisable = false;
    if (type === 'library' && filters[type] === 'vulnerability') {
      shouldDisable = true;
    }
    if (type === 'vulnerability' && filters[type] === 'library') {
      shouldDisable = true;
    }
    return shouldDisable;
  };
  render() {
    const { name } = this.props;
    const { dateOpt } = this.props.searchDataState;
    const {
      [`${name}-${DROPDOWN_OPT_KEY}`]: dropdownSelection = '',
      [`${name}-startDate`]: startDate = null,
      [`${name}-endDate`]: endDate = null,
      [`${name}-rangeFocused`]: rangeFocused = null,
    } = dateOpt;
    return (
      <div className="col-1-1 pr+ -ml--">
        <Select
          disabled={this.shouldDisableDateFields()}
          name="form-field-name"
          value={dropdownSelection}
          options={MODEL.dateRangeOptions}
          onChange={item => this.onDropdownListSelected(item)}
        />

        {dropdownSelection === 'custom' && (
          <div className="pt-">
            <DateRangePicker
              disabled={this.shouldDisableDateFields()}
              startDate={startDate}
              endDate={endDate}
              numberOfMonths={2}
              displayFormat={'YYYY-MM-D'}
              onDatesChange={({ startDate, endDate }) =>
                this.onCustomRangeSelect(startDate, endDate)
              }
              focusedInput={rangeFocused}
              onFocusChange={focusedInput => this.updateDateOpt('rangeFocused', focusedInput)}
              hideKeyboardShortcutsPanel={true}
              isOutsideRange={() => false}
            />
          </div>
        )}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    searchDataState: state.searchDataState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(searchActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CSDateFilter);
